<template>
  <div id="app">
		<keep-alive>
			<router-view v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>

		<router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>

import Vue from 'vue';
import Vant from 'vant';
import 'vant/lib/index.css'; 


Vue.use(Vant)
export default {
  computed: {
    },
  data(){
    return {
      active:"taskList"
    }
  },
  methods:{
  },
  watch: {
		$route: function() {
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		}
  },
  created(){
  }
}
</script>
<style>
.toast-class{
  width:80% !important;
}
</style>
